import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Explorer: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '32px',
      height: '32px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path d="M6.65913 7.99414V21.333" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99385 26.6695H5.32608C4.5895 26.6693 3.99245 26.0722 3.99219 25.3357V22.6679C3.99245 21.9313 4.5895 21.3342 5.32608 21.334H7.99385C8.73043 21.3342 9.32748 21.9313 9.32774 22.6679V25.3357C9.32748 26.0722 8.73043 26.6693 7.99385 26.6695V26.6695Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99385 26.6695H5.32608C4.5895 26.6693 3.99245 26.0722 3.99219 25.3357V22.6679C3.99245 21.9313 4.5895 21.3342 5.32608 21.334H7.99385C8.73043 21.3342 9.32748 21.9313 9.32774 22.6679V25.3357C9.32748 26.0722 8.73043 26.6693 7.99385 26.6695V26.6695Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.6657 7.99376H23.998C23.2614 7.99349 22.6643 7.39645 22.6641 6.65987V3.99209C22.6643 3.25552 23.2614 2.65847 23.998 2.6582H26.6657C27.4023 2.65847 27.9994 3.25552 27.9996 3.99209V6.65987C27.9994 7.39645 27.4023 7.99349 26.6657 7.99376Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99385 7.99376H5.32608C4.5895 7.99349 3.99245 7.39645 3.99219 6.65987V3.99209C3.99245 3.25552 4.5895 2.65847 5.32608 2.6582H7.99385C8.73043 2.65847 9.32748 3.25552 9.32774 3.99209V6.65987C9.32748 7.39645 8.73043 7.99349 7.99385 7.99376Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99385 7.99376H5.32608C4.5895 7.99349 3.99245 7.39645 3.99219 6.65987V3.99209C3.99245 3.25552 4.5895 2.65847 5.32608 2.6582H7.99385C8.73043 2.65847 9.32748 3.25552 9.32774 3.99209V6.65987C9.32748 7.39645 8.73043 7.99349 7.99385 7.99376Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.32031 24.0029H11.9881" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22.6592 5.32905H9.32031" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M25.331 7.99414V10.6619" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M25.3023 17.3671C27.3211 19.3859 27.1033 22.7904 24.6522 24.5121C23.0923 25.6071 20.9134 25.6071 19.3535 24.5121C16.9008 22.792 16.6847 19.3859 18.7034 17.3671C20.5261 15.5443 23.4811 15.5443 25.3023 17.3671"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.0026 26.6667L25.3359 24"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const ExplorerDark: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '24px',
      height: '24px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path d="M6.65913 7.99805V21.3369" stroke="#090C18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99385 26.6715H5.32608C4.5895 26.6712 3.99245 26.0742 3.99219 25.3376V22.6698C3.99245 21.9332 4.5895 21.3362 5.32608 21.3359H7.99385C8.73043 21.3362 9.32748 21.9332 9.32774 22.6698V25.3376C9.32748 26.0742 8.73043 26.6712 7.99385 26.6715V26.6715Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99385 26.6715H5.32608C4.5895 26.6712 3.99245 26.0742 3.99219 25.3376V22.6698C3.99245 21.9332 4.5895 21.3362 5.32608 21.3359H7.99385C8.73043 21.3362 9.32748 21.9332 9.32774 22.6698V25.3376C9.32748 26.0742 8.73043 26.6712 7.99385 26.6715V26.6715Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.6735 7.99766H24.0058C23.2692 7.9974 22.6721 7.40035 22.6719 6.66378V3.996C22.6721 3.25942 23.2692 2.66237 24.0058 2.66211H26.6735C27.4101 2.66237 28.0072 3.25942 28.0074 3.996V6.66378C28.0072 7.40035 27.4101 7.9974 26.6735 7.99766Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99385 7.99766H5.32608C4.5895 7.9974 3.99245 7.40035 3.99219 6.66378V3.996C3.99245 3.25942 4.5895 2.66237 5.32608 2.66211H7.99385C8.73043 2.66237 9.32748 3.25942 9.32774 3.996V6.66378C9.32748 7.40035 8.73043 7.9974 7.99385 7.99766Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99385 7.99766H5.32608C4.5895 7.9974 3.99245 7.40035 3.99219 6.66378V3.996C3.99245 3.25942 4.5895 2.66237 5.32608 2.66211H7.99385C8.73043 2.66237 9.32748 3.25942 9.32774 3.996V6.66378C9.32748 7.40035 8.73043 7.9974 7.99385 7.99766Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.32812 24.0048H11.9959" stroke="#090C18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22.667 5.32905H9.32812" stroke="#090C18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M25.3388 7.99805V10.6658" stroke="#090C18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M25.3023 17.3671C27.3211 19.3859 27.1033 22.7904 24.6522 24.5121C23.0923 25.6071 20.9134 25.6071 19.3535 24.5121C16.9008 22.792 16.6847 19.3859 18.7034 17.3671C20.5261 15.5443 23.4811 15.5443 25.3023 17.3671"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.0026 26.6667L25.3359 24"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
